// extracted by mini-css-extract-plugin
export var hideEditor = "_lq-2";
export var infoIcon = "_lq-3";
export var label = "_lq-1";
export var labelContainer = "_lq-0";
export var readonlyText = "_lq-4";